<template>
  <div>
    <el-row type="flex" justify="end">
      <el-col :span="3" :offset="1">
        <EmployeeSelector
          placeholder="Empleados"
          @selection-change="OnCxCEmployeeSelected"
          size="small"
          v-if="isView"
        />
      </el-col>
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="onCreateCXC"
        v-if="!isView"
      />
    </el-row>
    <el-row>
      <rabbey-table-3
        :data="CXCReportDataFiltered"
        :columns="Columns"
        :actions="actions"
        :loading="fetchingCxCData"
        @rtable-push-action="actionHandler"
      />
    </el-row>

    <AddNewCXC
      :AddCXCisVisible="AddCXCisVisible"
      :EmployeeInfo="EmpleeInfo"
      @onAddCXCdialogClose="onAddCXCdialogClose"
      @RechargeCXC="GetCXCReport"
    />
    <CXCdetails
      :detailIsVisible="detailIsVisible"
      :CXCdata="CXCdata"
      @closingCXCdetailDrawer="closingCXCdetailDrawer"
    />
  </div>
</template>

<script>
import AddNewCXC from "@/views/apps/employees/profiles/CXCemployees/AddNewCXC.vue";
import CXCdetails from "@/views/apps/employees/profiles/CXCemployees/CXCdetails.vue";
import { formatMonto } from "@/utils";
import PerfilPerson from "@/views/apps/employees/profiles/CXCemployees/functionals/employeePictureForCXC.vue";
import EmployeeSelector from "@/components/Company/EmployeeSelector.vue";

export default {
  name: "CXCemployees",
  components: {
    AddNewCXC,
    CXCdetails,
    EmployeeSelector
  },
  props: {
    EmpleeInfo: {
      type: Object,
      default: () => {}
    },
    isView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      AddCXCisVisible: false,
      CXCReportData: [],
      EmployeeSelected: 0,
      detailIsVisible: false,
      fetchingCxCData: false,
      CXCdata: {},
      Columns: [
        {
          prop: "epmployee.FullName",
          label: "Empleado",
          "min-width": 130,
          formatter: PerfilPerson
        },
        {
          label: "Descripcion",
          prop: "Descripcion",
          "min-width": 200
        },
        {
          label: "Monto Pagado",
          prop: "MonotoPagado",
          "min-width": 100,
          formatter: (row) => formatMonto(row.MonotoPagado)
        },
        {
          label: "Monto Pendiente",
          prop: "MontoPendiente",
          "min-width": 100,
          formatter: (row) => formatMonto(row.MontoPendiente)
        },
        {
          label: "Monto Total",
          prop: "MontoTotal",
          "min-width": 100,
          formatter: (row) => formatMonto(row.MontoTotal)
        }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver detalles",
          command: "view-cxc-details"
        },
        {
          icon: "el-icon-delete",
          label: "Borrar este registro",
          command: "delete-cxc"
        }
      ]
    };
  },
  mounted() {
    this.GetCXCReport();
  },
  computed: {
    CXCReportDataFiltered() {
      let cxcreportdatafiltered = this.CXCReportData;
      if (!this.isView) {
        cxcreportdatafiltered = this.CXCReportData.filter(
          (cxc) => cxc.EmpleadoId === this.EmpleeInfo.Id
        );
      } else {
        if (this.EmployeeSelected !== 0) {
          cxcreportdatafiltered = this.CXCReportData.filter(
            (cxc) => cxc.EmpleadoId === this.EmployeeSelected
          );
        }
      }

      return cxcreportdatafiltered;
    }
  },
  methods: {
    onCreateCXC() {
      this.AddCXCisVisible = true;
    },
    onAddCXCdialogClose() {
      this.AddCXCisVisible = false;
    },
    async GetCXCReport() {
      this.fetchingCxCData = true;
      const uriparams = {
        params: {
          allEmployees: true
        }
      };
      await this.$http.get("/api/CXC/GetCXC", uriparams).then((resp) => {
        this.CXCReportData = resp.data;
        this.AddCXCisVisible = false;
      });
      this.fetchingCxCData = false;
    },
    actionHandler(action) {
      switch (action.command) {
        case "view-cxc-details": {
          this.CXCdata = action.row;
          this.detailIsVisible = true;
          break;
        }
        case "delete-cxc": {
          this.deleteCXC(action.row);
          break;
        }
      }
    },
    closingCXCdetailDrawer() {
      this.detailIsVisible = false;
    },
    async RecalculatePayroll() {
      let body = {};
      await this.$http
        .put("/api/Payroll/RecalcularNominaDesdeFuera", body)
        .then(() => {
          this.$message.success("CxcAgregado");
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async deleteCXC(cxc) {
      const body = {
        params: {
          IdCXC: cxc.Id
        }
      };

      await this.$http
        .delete("/api/CXC/deleteCXC", body)
        .then(async () => {
          await this.RecalculatePayroll();
          await this.GetCXCReport();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    OnCxCEmployeeSelected(employee) {
      this.EmployeeSelected = employee;
    }
  }
};
</script>

<style></style>
